export default {
  created () {
    this.singleActions = [
      {
        label: this.$t('scope.text_18'),
        permission: 'cost_conversions_delete',
        action: (obj) => {
          this.createDialog('DeleteResDialog', {
            vm: this,
            data: [obj],
            columns: this.columns,
            title: this.$t('scope.text_18'),
            name: this.$t('bill.cost_conversion'),
            onManager: this.onManager,
          })
        },
        meta: (obj) => this.$getDeleteResult(obj),
      },
    ]
  },
}
